// Reads a value at a dotted path inside a nested object/array.
// Mirrors setByPath: numeric segments index into arrays/objects
// ("gallery.0.image", "scroll.frames.2.image"). Returns undefined when
// any intermediate node is missing, so callers can fall back to a default.
export function getByPath(obj: unknown, path: string): unknown {
  if (!path) return obj;
  const parts = path.split('.');
  let node: unknown = obj;
  for (const key of parts) {
    if (node == null || typeof node !== 'object') return undefined;
    node = (node as Record<string, unknown>)[key];
  }
  return node;
}
